<template>
    <b-card-text>
        <p class="mb-0" style="font-size: 21px"><b>Datos de la compañia</b></p>
        <b-row>
            <b-col cols="12" md="6">
                <ValidationProvider name="Nombre de la compañia"  rules="required|min:3" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Nombre:"
                        label-for="formDataCompanyName">
                        <b-form-input
                            id="formDataCompanyName"
                            v-model="formData.companyName"
                            type="text"
                            autocomplete="off"
                            required
                            :state="errors[0] ? false : (valid ? true : null)"
                            placeholder="Ingrese el nombre"
                            ></b-form-input>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="4">
                <ValidationProvider name="Numero documento de la compañia"  rules="numeric_string|required|min:3" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Numero de Documento:"
                        label-for="formDataCompanyNitNumber">
                        <b-form-input
                            id="formDataCompanyNitNumber"
                            v-model="formData.companyNit"
                            type="text"
                            autocomplete="off"
                            required
                            :state="errors[0] ? false : (valid ? true : null)"
                            placeholder="Ingrese el numero de documento sin cod. Verificación"
                            ></b-form-input>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <p class="mb-0" style="font-size: 21px"><b>Permisos de la compañia</b></p>
                <b-row>
                    <div v-for="(item, index) in permissionList" :key="index">
                        <b-col cols="12" md="12" v-for="(item, key) in item" :key="key">
                            <p class="mb-0" style="font-size: 18px">{{index}}</p>
                            <b-form-checkbox
                                v-model="permissions[key]"
                                :value=key.checked
                                >
                                {{item}}
                            </b-form-checkbox>
                        </b-col>
                    </div>
                </b-row>
            </b-col>
        </b-row>
    </b-card-text>
</template>
<script>
import { mapMutations } from 'vuex'

import { ValidationProvider, extend } from 'vee-validate';

extend('numeric_string', {
  validate: value => /^[0-9]+$/.test(value),
  message: 'Este campo solo acepta números sin caracteres especiales.'
});

export default {
    name: "CompanyDataForm",
    props: {
        formData: {
            type: Object
        },
        permissions: {
            type: Object
        }
    },
    data(){
        return{
            permissionList: [],
        }
    },
    components: {
        ValidationProvider
    },
    created(){
        this.getCompanyPermissions();
    },
    methods: {
        ...mapMutations(['setLoading']),
        async getCompanyPermissions(){
            this.setLoading(true)
            await this.$conectar.post('/admin/empresas/get-available-permissions-list-empresa')
            .then(response=>{
                this.permissionList = response.data.permissions;
            })
            .catch(response =>{
                console.log(response);
            })
            this.setLoading(false)
        }
    }
    
}
</script>